export default __webpack_public_path__ + "static/media/logo_header_small.47c02a2c.png";